import { createContext } from 'react';
import { CountryCodes } from '@/services/commonService';

// ================================
// CONTEXT TYPES & INTERFACE
// ================================

export interface CountryContextValue {
  // Core data
  countryCodes: CountryCodes[];
  isLoading: boolean;
  error: Error | null;
  isUsingFallback: boolean;

  // Error handling utilities
  retry: () => void;
  hasError: boolean;

  // Phone validation utilities
  validatePhoneInput: (value: string) => string;
  getCountryByCode: (
    countryCode: string,
    abbreviation?: string,
  ) => CountryCodes | undefined;
  getCountryCodeByName: (countryName: string) => string | undefined;
  validatePhoneLength: (
    phoneNumber: string,
    countryCode: string,
  ) => { isValid: boolean; error?: string };
  getPhoneMaxLength: () => number;
  getPhoneValidationMessage: () => string;
  getCountryCodeDisplay: (countryCode: string) => string;
}

// ================================
// CONTEXT CREATION
// ================================

export const CountryContext = createContext<CountryContextValue | undefined>(
  undefined,
);
